import React from "react";
import ChristmasPartyRegistration from "./ChristmasPartyRegistration";
import RestaurantTableReservation from "./RestaurantTableReservation";
import FamilyEveningRegistration from "./FamilyEvening";
import FestiveDinner from "./FestiveDinner";

const formComponents: Record<string, React.ComponentType> = {
  christmasPartyRegistration: ChristmasPartyRegistration,
  restaurantTableReservation: RestaurantTableReservation,
  familyEveningReservation: FamilyEveningRegistration,
  festiveDinner: FestiveDinner,
};

export const FormRenderer = ({ formKey }: { formKey?: string }) => {
  if (!formKey) return null;

  const FormComponent = formComponents[formKey];

  return FormComponent ? <FormComponent /> : null;
};